import { remove } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { invalidateGetWorkerQuery } from "@src/appV2/Worker/api/useGetWorker";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

export function useCancelAccountDeletionRequest(
  options: UseMutationOptions<void, AxiosError, void> = {}
): UseMutationResult<void, AxiosError, void> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await remove({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/account-deletion-requests`,
        responseSchema: z.any(),
      });
    },
    onSuccess: async () => {
      await invalidateGetWorkerQuery(queryClient);
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CANCEL_ACCOUNT_DELETION_REQUEST_FAILURE,
    },
    ...options,
  });
}
